import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Switch from 'app/scripts/components/common/inputs/customs/switch';
import { autobind } from 'core-decorators';
import { getConversationSurveyConfig, saveConversationSurveyConfig } from '../api';
import { get } from 'lodash-es';

type Props = {
  spotId: string;
  spotName: string;
};

type State = {
  isEnabled: boolean;
  lastEnabled: string;
};

class ConversationSurveyToggle extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isEnabled: false,
      lastEnabled: null
    };
  }

  static defaultProps = {
    spotId: null
  };

  static propTypes = {
    spotId: PropTypes.string.isRequired
  };

  async componentDidMount() {
    const { spotId } = this.props;
    try {
      const ConversationSurveyConfigRes = await getConversationSurveyConfig(spotId);
      let currentConfig =
        get(ConversationSurveyConfigRes, ['tenant', 'conversation-survey', 'enabled', 'value']) ||
        false;
      const lastEnabled = get(ConversationSurveyConfigRes, [
        'tenant',
        'spotlight',
        'enabled',
        'updated_at'
      ]);
      this.setState({ isEnabled: currentConfig, lastEnabled });
    } catch (error) {
      console.error(error);
    }
  }

  @autobind
  async onChange(value: boolean) {
    const { spotId, spotName } = this.props;
    const { lastEnabled } = this.state;
    try {
      await saveConversationSurveyConfig(spotId, {
        enabled: { enabledValue: value, lastEnabled },
        spotName
      });
      this.setState({ isEnabled: value });
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    return (
      <Switch
        title="Enable Conversation Survey"
        description=" "
        value={this.state.isEnabled}
        onChange={this.onChange}
      />
    );
  }
}

export default ConversationSurveyToggle;
